<div class="header-wrap sticky-top" id="landingpage-header-child">
    <!-- menu-main -->
    <div class="container">
        <nav class="navbar navbar-expand-md navbar-dark">
            <a class="navbar-brand" (click)="backToBuyPakage()">
                <img class="img-responsive" src="../../../../../assets/images/logo_vcontract_w.png" alt="logo" width="50%">
            </a>
            <!--button show only mobile -->
            <!-- <button class="navbar-toggler" type="button" data-toggle="collapse"
                data-target="#collapsibleNavbar">
                <span class="navbar-toggler-icon"></span>
            </button> -->
            <div class="navbar-toggler-bar" data-toggle="collapse" data-target="#collapsibleNavbar" aria-expanded="false">
                <div class="bar1"></div>
                <div class="bar2"></div>
                <div class="bar3"></div>
            </div>

            <div class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                <div class="form-inline">
                    <!-- <ul class="navbar-nav mr-auto">
                        <li class="nav-item pr-4">
                            <a class="nav-link font-weight-bold"
                                href="#feature">{{'lading_page.header.feature' | translate}}</a>
                        </li>
                        <li class="nav-item pr-4">
                            <a class="nav-link font-weight-bold"
                                href="#contact">{{'lading_page.header.service_charge' | translate}}</a>
                        </li>
                        <li class="nav-item pr-4">
                            <a class="nav-link font-weight-bold"
                                href="#contact">{{'lading_page.header.support' | translate}}</a>
                        </li>
                    </ul> -->
                    <ul class="navbar-nav mr-auto" style="margin-right: 0px !important;">
                        <li class="nav-item {{item.children ? 'dropdown' : ''}} pr-4" *ngFor="let item of listHeads">
                            <ng-container *ngIf="!item.children">
                                <!-- <a class="nav-link font-weight-bold"
                                    (click)="hyperlink(item.link, item.target)">{{item.name}}</a> -->
                                <a class="nav-link font-weight-bold"
                                    (click)="hyperlink(item.link, item.target)">{{getTextMenuOptions(item)}}</a>
                            </ng-container>
                            <ng-container *ngIf="item.children">
                                <a class="nav-link font-weight-bold dropdown-toggle" id="navbarDropdownMenuLink"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    (click)="hyperlink(item.link, item.target)">{{item.name}}</a>
                                <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink"
                                    style="padding: 0; border-radius: 4px; margin-top: 0;">
                                    <li *ngFor="let sub of item.subMenu"><a class="dropdown-item"
                                            (click)="hyperlink(sub.link, sub.target)">{{sub.name}}</a></li>
                                </ul>
                            </ng-container>
                        </li>
                    </ul>
                    <div class="space-inline-header"></div>
                    <a class="btn btn-primary btn-rounded-10 iq-box-shadowmr-2 btn-contract-authentication mr-1 font-weight-bold"
                        href="https://xacthuc.ceca.gov.vn/">{{'lading_page.header.contract_authencation' | translate}}</a>
                    <div class="space-inline-header"></div>
                    <button class="btn btn-primary btn-rounded-10 iq-box-shadow btn-trial font-weight-bold" [disabled]="disableLogin"
                        routerLink="/home-enterprise" (click)="toLogin()">{{'lading_page.header.login' | translate}}</button>
                    <!-- <a class="cart-main" (click)="navigationToListCart(numberItemCart);">
                        <mat-icon [matTooltip]="'header.cart' | translate" style="color: white;">
                            {{numberItemCart !== 0 ? 'shopping_cart' : 'remove_shopping_cart'}}
                        </mat-icon>
                        <span class="number-cart">({{numberItemCart}})</span>
                    </a> -->

                    <ul class="navbar-nav navbar-lang ml-2">
                    <!-- Vietnamese -->
                    <li>
                        <button class="select-language" [matMenuTriggerFor]="menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
                          <div>
                            <img *ngIf="langCurrent == 'vi'" class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
                            <img *ngIf="langCurrent == 'en'" class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
                            <img *ngIf="langCurrent == 'zh'" class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
                            <img *ngIf="langCurrent == 'es'" class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
                          </div>
                          <span class="">{{getCurrentNameLanguage()}}</span>
                          <div class="">
                              <em *ngIf="isOpen" class="material-icons">keyboard_arrow_up</em>
                              <em *ngIf="!isOpen" class="material-icons">keyboard_arrow_down</em>
                          </div>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button mat-menu-item (click)="onChangeLanguage('vi')" style="width: 140px;"
                              [ngClass]="{'active-btn': langCurrent == 'vi'}">
                              <img class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
                              {{'Tiếng Việt' | translate}}
                          </button>
                          <button mat-menu-item (click)="onChangeLanguage('en')" style="width: 140px;"
                              [ngClass]="{'active-btn': langCurrent == 'en'}">
                              <img class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
                              {{'English' | translate}}
                          </button>
                          <button mat-menu-item (click)="onChangeLanguage('zh')" style="width: 140px;"
                              [ngClass]="{'active-btn': langCurrent == 'zh'}">
                              <img class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
                              {{'中国人' | translate}}
                          </button>
                          <button mat-menu-item (click)="onChangeLanguage('es')" style="width: 140px;"
                              [ngClass]="{'active-btn': langCurrent == 'es'}">
                              <img class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
                              {{'Español' | translate}}
                          </button>
                        </mat-menu>
                      </li>
                </ul>
                </div>
            </div>
        </nav>
    </div>

</div>
